module.exports = "stepper{padding-top:15px}\n"